if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

/* Era of Siya mobile gallery force-layout v2 */
(function(){
 function setup(root){
  if(!root)return;
  var list=root.querySelector('.product__media-list.slider--mobile');
  if(!list)return;
  var slides=Array.from(list.children).filter(function(el){return el.classList.contains('product__media-item')});
  if(!slides.length)return;
  list.style.setProperty('display','flex','important');list.style.setProperty('flex-direction','row','important');list.style.setProperty('flex-wrap','nowrap','important');list.style.setProperty('gap','0','important');list.style.setProperty('width','100%','important');list.style.setProperty('overflow-x','auto','important');list.style.setProperty('overflow-y','hidden','important');list.style.setProperty('scroll-snap-type','x mandatory','important');list.style.setProperty('-webkit-overflow-scrolling','touch','important');list.style.setProperty('scrollbar-width','none','important');
  slides.forEach(function(slide){slide.style.setProperty('display','block','important');slide.style.setProperty('box-sizing','border-box','important');slide.style.setProperty('flex','0 0 100%','important');slide.style.setProperty('width','100%','important');slide.style.setProperty('min-width','100%','important');slide.style.setProperty('max-width','100%','important');slide.style.setProperty('margin','0','important');slide.style.setProperty('scroll-snap-align','start','important')});
  if(root.dataset.eraSwipeReady==='1')return;root.dataset.eraSwipeReady='1';var sx=0,sy=0;
  list.addEventListener('touchstart',function(e){if(e.touches&&e.touches.length===1){sx=e.touches[0].clientX;sy=e.touches[0].clientY}},{passive:true});
  list.addEventListener('touchend',function(e){if(!e.changedTouches||!e.changedTouches.length)return;var dx=e.changedTouches[0].clientX-sx,dy=e.changedTouches[0].clientY-sy;if(Math.abs(dx)<35||Math.abs(dx)<Math.abs(dy)*1.15)return;var current=Math.round(list.scrollLeft/Math.max(1,list.clientWidth));var next=Math.max(0,Math.min(slides.length-1,current+(dx<0?1:-1)));list.scrollTo({left:next*list.clientWidth,behavior:'smooth'})},{passive:true});
  var prev=root.querySelector('button[name="previous"]'),next=root.querySelector('button[name="next"]');if(prev)prev.addEventListener('click',function(){list.scrollTo({left:Math.max(0,list.scrollLeft-list.clientWidth),behavior:'smooth'})});if(next)next.addEventListener('click',function(){list.scrollTo({left:Math.min((slides.length-1)*list.clientWidth,list.scrollLeft+list.clientWidth),behavior:'smooth'})});
 }
 function all(){if(!window.matchMedia('(max-width: 749px)').matches)return;document.querySelectorAll('slider-component[id^="GalleryViewer-"]').forEach(setup)}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();window.addEventListener('resize',all);document.addEventListener('shopify:section:load',all);
})();
